/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Add2Inputs */

const vi_cmspostcategory_add2 = /** @type {(inputs: Cmspostcategory_Add2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm chuyên mục`)
};

/**

* @param {Cmspostcategory_Add2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_add2 = /** @type {((inputs?: Cmspostcategory_Add2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Add2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_add2(inputs)
});
export { cmspostcategory_add2 as "cmsPostCategory_add" }